import { render, staticRenderFns } from "./etranslate-component.vue?vue&type=template&id=2735c326&scoped=true&"
import script from "./etranslate-component.vue?vue&type=script&lang=ts&"
export * from "./etranslate-component.vue?vue&type=script&lang=ts&"
import style0 from "./etranslate-component.vue?vue&type=style&index=0&id=2735c326&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2735c326",
  null
  
)

export default component.exports